<template>
  <div class="chart-header__wrapper">
    <component
      :is="value.meta.headingLevel || 'h2'"
      class="pigeondoc__heading chart-header__title"
      :id="`${value.uuid}-chart-title`"
    >
      <span v-html="value.content.title"></span>
    </component>

    <div class="chart-header__display-type-btns" style="text-align: right">
      <!-- If it is not a sentiment chart, show table -->
      <div v-if="!value.meta.isSentimentChart">
        <button
          aria-label="chart view"
          type="button"
          cursor="pointer"
          :aria-pressed="String(displayChart)"
          :class="['chart-header__display-type-btn', { 'selected-btn': displayChart }]"
          @click="$emit('set-display-chart', true)"
        >
          <chartIcon />
        </button>
        <button
          aria-label="table view"
          :aria-pressed="String(!displayChart)"
          :class="['chart-header__display-type-btn', { 'selected-btn': !displayChart }]"
          type="button"
          @click="$emit('set-display-chart', false)"
        >
          <tableIcon />
        </button>
        <!-- <button v-if="!['report', 'report-edit'].includes($route.name)" aria-label="table view" -->
        <button
          v-if="['projectAnalysisText'].includes($route.name)"
          aria-label="table view"
          :aria-pressed="String(!displayChart)"
          :class="['chart-header__display-type-btn', { 'selected-btn': !displayChart }]"
          type="button"
          @click="$emit('deletChart')"
        >
          <deleteIcon />
        </button>
      </div>
      <!-- if it is sentiment chart, show table only if it is in sentiment mode -->
      <div v-if="value.meta.isSentimentChart && value.meta.isSentimentMode">
        <button
          aria-label="chart view"
          type="button"
          cursor="pointer"
          :aria-pressed="String(displayChart)"
          :class="['chart-header__display-type-btn', { 'selected-btn': displayChart }]"
          @click="$emit('set-display-chart', true)"
        >
          <chartIcon />
        </button>
        <button
          aria-label="table view"
          :aria-pressed="String(!displayChart)"
          :class="['chart-header__display-type-btn', { 'selected-btn': !displayChart }]"
          type="button"
          @click="$emit('set-display-chart', false)"
        >
          <tableIcon />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import chartIcon from '../../assets/chart.svg';
import tableIcon from '../../assets/table.svg';
import deleteIcon from '../../assets/remove.svg';

export default {
  name: 'ChartHeader',
  components: {
    chartIcon,
    tableIcon,
    deleteIcon,
  },
  props: {
    value: PigeonDocNodeModel,
    displayChart: {
      default: () => false,
      type: Boolean,
    },
  },
};
</script>

<style>
.chart-header__wrapper {
  display: flex;
  margin: 0 5%;
  justify-content: space-between;
}

.chart-header__title {
  text-align: center;
  flex: 2;
}

.chart-header__display-type-btn {
  background: #fff;
  border: 0.5px solid #eaeaea;
  color: #747474;
  cursor: pointer;
  padding: 0.5rem 0.55rem;
  width: 2.5rem;
}

.chart-header__display-type-btn:first-child {
  border-radius: 5px 0px 0px 5px;
}

.chart-header__display-type-btn:last-child {
  border-radius: 0px 5px 5px 0px;
}

.chart-header__display-type-btn.selected-btn {
  color: #30629a;
  background: rgba(0, 0, 0, 0.05);
}

.chart-header__display-type-btn svg {
  display: inline-block;
  fill: currentColor;
  height: 1.25rem;
  vertical-align: middle;
}
</style>
